import VisuallyHidden from '../../_VisuallyHidden.js';
import { accessibleKeyName, condensedKeyName, fullKeyName } from '../key-names.js';
import { useIsMacOS } from '../../hooks/useIsMacOS.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** Renders a single key with accessible alternative text. */
const Key = ({
  name,
  format
}) => {
  const isMacOS = useIsMacOS();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      children: accessibleKeyName(name, isMacOS)
    }), /*#__PURE__*/jsx("span", {
      "aria-hidden": true,
      children: format === 'condensed' ? condensedKeyName(name, isMacOS) : fullKeyName(name, isMacOS)
    })]
  });
};

export { Key };
